import { Box, type BoxProps, Flex, Image, Text } from '@mantine/core'

import { type CoreQuotePreview, type CoreUserAddress } from '@flecto/types'
import { TextDate } from '@flecto/ui'
import { getImageUrl, useAddressInline } from '@flecto/utils'

import { useDocumentState } from '../../hooks/useDocumentState'
import styles from './styles.module.css'

export type SectionHeaderProps = BoxProps

export function SectionHeader({ ...props }: SectionHeaderProps) {
  const { documentPreview, translate} = useDocumentState()

  const quoteId = (documentPreview as CoreQuotePreview )?.booking_settings?.document_next_quote_id

  const logoImg = getImageUrl(documentPreview?.owner?.avatar_url ?? '')

  const getAAddressLabel = useAddressInline()

  return (
    <Flex align='flex-start' justify='space-between' {...props}>
      <Box>
        <Text size='xl' fw={500}>
          {translate?.('label_quote_id', { id: quoteId })}
        </Text>
        <Text size='md' fw={500} c='gray.7' data-testid="owner-name">
          {documentPreview?.owner?.name}
        </Text>
        {documentPreview?.owner_address && (
          <Text c='gray.7' mt='sm' size='md'>
            {getAAddressLabel(
              documentPreview?.owner_address as unknown as CoreUserAddress
            )}
          </Text>
        )}
        <Text c='gray.7' size='md'>
          {documentPreview?.owner?.email}
        </Text>
        <Text c='gray.7' size='md'>
          {documentPreview?.owner?.phone_number_country_code}{' '}
          {documentPreview?.owner?.phone_number}
        </Text>
      </Box>
      <Flex direction='column' align='flex-end' justify='flex-end'>
        {logoImg && <Image src={logoImg ?? ''} alt='brand' className={styles.quoteLogo} />}
        <Flex gap='xs' mt='md'>
          <Text size='md'>{translate?.('label_date')}:</Text>
          <TextDate size='md' date={new Date().toDateString()} />
        </Flex>
        {documentPreview?.booking_settings
          ?.documents_quote_validity_period_active && (
          <Text fw={500} size='md'>
            {translate?.('label_valid_for_days', {
              count:
                documentPreview?.booking_settings?.documents_quote_validity_period,
            })}
          </Text>
        )}
      </Flex>
    </Flex>
  )
}
